import { el, clear } from "../dom.js";
import type { Option } from "../../content/types.js";

export interface QuestionScreenProps {
  eyebrow: string;
  prompt: string;
  progressLabel: string;
  options: Option[];
  selectedOptionId?: string | undefined;
  onSelect: (optionId: string) => void;
  onBack?: (() => void) | undefined;
}

export function renderQuestion(container: HTMLElement, props: QuestionScreenProps): void {
  clear(container);
  const optionButtons = props.options.map((option) =>
    el(
      "button",
      {
        className: "option",
        type: "button",
        "aria-pressed": String(option.id === props.selectedOptionId),
        "data-option-id": option.id,
      },
      [option.text],
    ),
  );

  const fieldset = el("fieldset", {}, [
    el("legend", {}, [props.prompt]),
    el("div", { className: "option-list", role: "group", "aria-label": props.prompt }, optionButtons),
  ]);

  const children: (Node | string)[] = [
    el("div", { className: "progress" }, [props.progressLabel]),
    el("span", { className: "eyebrow" }, [props.eyebrow]),
    fieldset,
  ];
  if (props.onBack) {
    children.push(
      el("button", { className: "back-link", type: "button" }, ["← Back"]),
    );
  }

  const screen = el("section", { className: "screen" }, children);

  for (const button of optionButtons) {
    button.addEventListener("click", () => {
      const id = button.dataset["optionId"];
      if (id) props.onSelect(id);
    });
  }
  if (props.onBack) {
    screen.querySelector(".back-link")!.addEventListener("click", props.onBack);
  }

  container.append(screen);
}
